import * as Yup from 'yup'

export const textSettingsSchema = Yup.object().shape({
    messageType: Yup.number().required("Solution is required"),
    personalAccessToken: Yup.string().required("Personal Access Token is required"),
})